export default __webpack_public_path__ + "98672dde87654c004f80b7301e67ce45.png";